<template>
  <header class="education-page-header">
    <div>
      <h1>{{ title }}</h1>
      <p v-if="description">{{ description }}</p>
    </div>
    <div class="education-page-actions"><slot name="actions" /></div>
  </header>
</template>

<script setup lang="ts">
defineOptions({ name: 'EducationPageHeader' })
defineProps<{ title: string; description?: string }>()
</script>

<style scoped>
.education-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.education-page-header h1 {
  margin: 0;
  color: #17222d;
  font-size: 22px;
}
.education-page-header p {
  margin: 6px 0 0;
  color: #697681;
  font-size: 14px;
}
.education-page-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
@media (max-width: 767px) {
  .education-page-header {
    flex-direction: column;
  }
}
</style>
